import { useAbility } from '@casl/react';

export function useZenOSAbility() {
  return useAbility();
}

export default useZenOSAbility;
